import _isNil from 'lodash/isNil';

import { CONTENT_NODE_SUGGESTION_TYPES } from 'components/modules/content/constants';

export function getNonReviewedSuggestionsForPage(pageId, suggestions) {
  return suggestions.filter(
    ({ page, approved, approvedBy, type }) =>
      page === pageId &&
      _isNil(approved) &&
      _isNil(approvedBy) &&
      CONTENT_NODE_SUGGESTION_TYPES.includes(type),
  );
}
